import { ContainerModule } from 'inversify';
import { ImagesService } from './Images.service';
import { RequestSliceStrategiesProvider } from './ImagesRequestSliceStrategies';
import type { IRequestSliceStrategiesProvider } from './interfaces';
import { TYPES } from './iocTypes';
import {
  type IImageScrollStrategiesFactory,
  ImageScrollStrategiesFactory
} from '@/engine/app/modules/images/ImageScrollStrategies.factory.ts';

export const imagesModule = new ContainerModule((bind) => {
  bind<ImagesService>(TYPES.ImagesService).to(ImagesService).inSingletonScope();
  bind<IImageScrollStrategiesFactory>(TYPES.ImageScrollStrategiesFactory)
    .to(ImageScrollStrategiesFactory)
    .inSingletonScope();
  bind<IRequestSliceStrategiesProvider>(TYPES.IRequestSliceStrategiesProvider).to(RequestSliceStrategiesProvider);
});
